import CustomList from "components/list/custom";
import React from "react";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE, ROUTE } from "@/lib/utils";
import { HoursCell, TotalHoursCell } from "@/components/hours/cell";
import { useParams } from "react-router-dom";
import EmployeeOverviewFilters from "@/modules/reports/timesheet/employees/detail/filters";

const EmployeeTimesheetOverview = () => {
  const { employeeId } = useParams();
  const filters = {
    employeeId: employeeId,
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
  };

  const columns = [
    {
      id: "name",
      accessorKey: "name",
      header: "Project",
    },
    {
      id: "planned",
      accessorKey: "planned",
      header: "Planned",
      cell: HoursCell,
      footer: TotalHoursCell("planned"),
    },
    {
      id: "logged",
      accessorKey: "logged",
      header: "Logged",
      cell: HoursCell,
      footer: TotalHoursCell("logged"),
    },
    {
      id: "approved",
      accessorKey: "approved",
      header: "Approved",
      cell: HoursCell,
      footer: TotalHoursCell("approved"),
    },
    {
      id: "unapproved",
      accessorKey: "unapproved",
      header: "Unapproved",
      cell: HoursCell,
      footer: TotalHoursCell("unapproved"),
    },
    {
      id: "unreviewed",
      accessorKey: "unreviewed",
      header: "Unreviewed",
      cell: HoursCell,
      footer: TotalHoursCell("unreviewed"),
    },
  ];

  return (
    <div className="flex-1 overflow-auto">
      <CustomList
        endPoint="custom-ui/get-project-type-wise-timesheet-summary"
        storageKey={employeeId}
        filters={filters}
        perPage={25}
        columns={columns}
        renderFilters={EmployeeOverviewFilters}
        teleportFilters={true}
        title="Employee Timesheet"
        showSearch={false}
        hidePagination={true}
        href={(item) => ROUTE.PROJECT(item.id)}
      />
    </div>
  );
};

export default EmployeeTimesheetOverview;
